import { switchMap, take } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { dataAccessEnvironment } from '../../models/data-access-environment';
import { requiredHeaders } from '../../models/required-headers';
import { ignoreData } from '../../utils/ignore-data';
import { postJwt } from '../authws/post-jwt';
import { routingProfileServiceEnvironment } from './routing-profile-service-environment';

export function deleteRoutingProfilesId(routingProfileId: number) {
  return postJwt({ authenticationToken: dataAccessEnvironment.authToken }).pipe(
    take(1),
    switchMap((jwt) => {
      return fromFetch(
        new Request(
          `${routingProfileServiceEnvironment.routingProfilesUrl}/${routingProfileId}`,
          {
            method: 'DELETE',
            headers: {
              ...requiredHeaders,
              Authorization: `bearer ${jwt.access_token}`,
            },
          }
        )
      ).pipe(ignoreData());
    })
  );
}
